<template>
 <div class="fuwupingtai">
   <a href="https://www.chinadata.cn/" class="box">
     <img src="../../../assets/img/001.png" alt="">
   </a>
   <a href="https://www.cdpee.org.cn" target="_blank" class="box">
     <img src="../../../assets/img/zmdt1.png" alt="">
   </a>
   <a href="https://www.hnzwfw.gov.cn/aisearch/index.html?areaCode=411700000000&serviceName=%E6%AE%8B%E7%96%BE%E4%BA%BA#/" target="_blank" class="box">
     <img src="../../../assets/img/zmdt2.png" alt="">
   </a>
  </div>
</template>

<script>
export default {
  name: 'fuwupingtai',
  components: {},
  data () {
     return {

   }
  },
  methods: {}
};
</script>

<style scoped>
  .fuwupingtai {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
.fuwupingtai .box{
  width:200px;
  height:100px;
  display: block;

}
.fuwupingtai .box img{
  width:200px;
  height:100px;

}

</style>



// WEBPACK FOOTER //
// src/views/front/components/fuwupingtai.vue